/** Chapi's one-click shortcuts. On their own so the router can validate `?ask=` without loading Chapi. */
export const SHORTCUTS = ['summarise_channel', 'summarise_conversation', 'draft_reply', 'make_task'] as const;
export type ChapiShortcut = (typeof SHORTCUTS)[number];
